import React, { FunctionComponent, useState } from 'react';
import styles from './TopBar.module.css';
import { AiFillCaretDown } from 'react-icons/ai';
import { AiOutlineSearch } from 'react-icons/ai';
import { BsFilter, BsPlus } from 'react-icons/bs';
import { FaChevronDown } from 'react-icons/fa';
import StatusFilter from '../StatusFilter/StatusFilter';
import Import from '../../Components/Import/Import';
import { BsColumnsGap } from 'react-icons/bs';
import { connect, useDispatch } from 'react-redux';
import { IoClose } from 'react-icons/io5';
import { MdDelete } from "react-icons/md";
import {
  setFilter,
  setRefreshCallLogs,
  setRefreshContacts,
  setRefreshTasks,
  setContactsSearchString,
  setTasksSearchString,
  setCallsSearchString,
  showSnackbarAction,
  updateStage,
  setProjectSearchString,
} from '../../Redux/actions';
import { useEffect } from 'react';
import { correctLeadCount } from '../../Services/organizations';
import DistributionModel from '../../Components/Modals/DistributionModel/DistributionModel';
import { IoIosRefresh } from 'react-icons/io';
import { themeColors } from "../../Components/theme";
// Import theme variables
import "../../theme-vars.css";
import { BiExport, BiTrash } from 'react-icons/bi';

type props = {
  user: any;
  history: any;
  title: string;
  path: string;
  // on selected leads, if we click on change owner, modal opens condition
  onClick?: () => void;
  // to show the change owner text condition
  owner?: boolean;
  // function from user panel
  changeOwner?: () => void;
  deleteSelected?: () => void;
  onChange?: (text: any) => void;
  setStatus?: (status: string) => void;
  filterText: string;
  status?: string;
  // sets condition for statusFilter component and there it is handled accordingly
  taskFilter?: boolean;
  // sets condition for statusFilter component and there it is handled accordingly
  projectFilter?: boolean;
  setColumnModal?: (data: boolean) => void;
  show: boolean;
  userRole: any;
  showStatusBox?: boolean;
  onExport?: () => void;
  // dropdown rights from organization panel shown in leads panel
  onCallLogsImport?: () => void;
  // dropdown rights from organization panel shown in leads panel
  onNotesImport?: () => void;
  // dropdown rights from organization panel shown in leads panel
  onTasksImport?: () => void;
  // edit records option on selecting a lead, opens a modal to update every selected lead
  setBulkEdit?: () => void;
  leadsStage: any;
  setAllLeads?: (data: boolean) => void;
  setListViewModal?: (data: boolean) => void;
  setApiModal?: (data: boolean) => void;
  setApiFilter?: (data: string) => void;
  apiFilterData?: string;
  organizationId: string;
  // to refresh
  setLoad?: (data: boolean) => void;
  setChangeStageModal?: (data: boolean) => void;
  setDeleteRecordsModal?: (data: boolean) => void;
  // for maintaining search after switiching panels, stored globally
  searchedString?: string;
  // if we select a lead with transfer status true, we won't allow to open change owner and edit bulk modals
  transferLeads?: any[];
  theme: any;
  titleDrillDown?: any;
  clearFilter?: () => void;
  role?: any;
};

const ApiTopBar: FunctionComponent<props> = ({
  user,
  history,
  title,
  path,
  onClick,
  owner,
  changeOwner,
  deleteSelected,
  onChange,
  setStatus,
  filterText,
  status,
  taskFilter,
  projectFilter,
  setColumnModal,
  show,
  userRole,
  showStatusBox,
  onExport,
  onCallLogsImport,
  onNotesImport,
  onTasksImport,
  setBulkEdit,
  leadsStage,
  setListViewModal,
  setApiModal,
  setApiFilter,
  apiFilterData,
  organizationId,
  setLoad,
  setChangeStageModal,
  setDeleteRecordsModal,
  searchedString,
  setAllLeads,
  transferLeads,
  theme,
  titleDrillDown,
  clearFilter,
  role
}) => {
  const [expand, setExpand] = useState(false);
  const [expandImport, setExpandImport] = useState(false);
  const [value, setValue] = useState('');
  const [showDistributionModal, setShowDistributionModal] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const dispatcher = useDispatch();
  const [openSearchBox, SetOpenSearchBox] = useState(false);
  const apiFilter = (event: any, filter: string) => {
    if (event.target.checked) {
      if (setApiFilter) {
        setApiFilter(filter);
      }
    } else {
      if (setApiFilter) {
        setApiFilter('');
      }
    }
  };

  // include transfer leads in contacts panel
  const transferLead = (event: any) => {
    if (setAllLeads && event.target.checked) {
      setAllLeads(true);
    } else {
      setAllLeads && setAllLeads(false);
    }
  };

  // on panel change, search pertains
  useEffect(() => {
    if (value !== searchedString) {
      setIsSearched(false);
    }
  }, [value]);

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className={styles.topBar} style={containerStyles}>
      {(title !== 'Add Project' && title !== "Add Call Logs" && title !== 'drilldown' && showStatusBox === true) && (
        <>
          {userRole !== 'Sales' && (
            <>
              <div style={{ display: 'flex', flexDirection: 'row', height: "100%", padding: "0px 5px", marginRight: -8 }}>
                {role !== 'Admin' && role !== "Replicate" && (
                  <button
                    className={
                      styles.tabButton +
                      ' ' +
                      styles.leftRounded
                    }
                    style={{
                      background: '#e6e6e6',
                      color: '#333',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 18px',
                      fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)",
                      minWidth: 135,
                      justifyContent: 'flex-start',
                      boxShadow: 'none',
                      border: 'none',
                      cursor: owner ? 'pointer' : 'not-allowed',
                      marginRight: 2,
                      opacity: owner ? 1 : 0.5,
                    }}
                    disabled={!owner}
                    onClick={() => {
                      transferLeads && transferLeads.includes(true)
                        ? dispatcher(
                          showSnackbarAction(
                            'Leads With Transfer Status TRUE Cannot Be Transfered!!',
                            'error'
                          )
                        )
                        : changeOwner && changeOwner();
                    }}
                  >
                    Change Owner
                  </button>
                )}
                {(
                  userRole === 'Lead Manager' ||
                  userRole === 'organization' ||
                  (role === 'Admin' && title === 'Add Contacts')
                ) && (
                    <button
                      className={
                        styles.tabButton +
                        " " +
                        styles.rightRounded +
                        (role === "Admin" ? " " + styles.leftRounded : "")
                      }
                      style={{
                        background: '#e6e6e6',
                        color: '#333',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 18px',
                        fontFamily: "var(--font-family-main)",
                        fontSize: "var(--font-size-small)",
                        minWidth: 100,
                        justifyContent: 'flex-start',
                        boxShadow: 'none',
                        border: 'none',
                        cursor: owner ? 'pointer' : 'not-allowed',
                        opacity: owner ? 1 : 0.5,
                      }}
                      disabled={!owner}
                      onClick={() => {
                        deleteSelected && deleteSelected();
                      }}
                    >
                      <BiTrash size={30} style={{ marginRight: 6, color: '#272944' }} />
                      Delete
                    </button>
                  )}
              </div>
              {expand === true && (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '22px',
                    justifyContent: 'center',
                  }}
                >
                  <StatusFilter
                    setStatus={(status) => setStatus && setStatus(status)}
                    status={status}
                    taskFilter={taskFilter}
                    projectFilter={projectFilter}
                    setExpand={(data) => setExpand(data)}
                    expand={expand}
                  />
                </div>
              )}
            </>
          )}
        </>
      )}
      {(title === 'Add Project' && showStatusBox === true) && (
        <>
          {userRole !== 'Sales' && (
            <div>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
               {owner && (userRole === "organization" || role === "Admin") && (
                  <div
                    className={styles.refreshIcon}
                  >
                    <button
                      className={
                        styles.tabButton +
                        " " +
                        styles.rightRounded +
                        " " + styles.leftRounded
                      }
                      style={{
                        background: '#e6e6e6',
                        color: '#333',
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        padding: '8px 18px',
                        fontFamily: "var(--font-family-main)",
                        fontSize: "var(--font-size-small)",
                        minWidth: 100,
                        justifyContent: 'flex-start',
                        boxShadow: 'none',
                        border: 'none',
                        cursor: owner ? 'pointer' : 'not-allowed',
                        opacity: owner ? 1 : 0.5,
                      }}
                      onClick={() => {
                        deleteSelected && deleteSelected();
                      }}
                    >
                      <BiTrash size={30} style={{ marginRight: 6, color: '#272944' }} />
                      Delete
                    </button>
                  </div>
                )}
              </div>
              {expand === true && (
                <div
                  style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '22px',
                    justifyContent: 'center',
                  }}
                >
                  <StatusFilter
                    setStatus={(status) => setStatus && setStatus(status)}
                    status={status}
                    taskFilter={taskFilter}
                    projectFilter={projectFilter}
                    setExpand={(data) => setExpand(data)}
                    expand={expand}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}

      {title === 'Add User' && (
        <>
          <button
            style={{ marginLeft: '20px' }}
            className={styles.addBox}
            onClick={() => {
              setListViewModal && setListViewModal(true);
            }}
          >
            Set List View
          </button>
          <button
            style={{ marginLeft: '20px' }}
            className={styles.addBox}
            onClick={() => {
              setLoad && setLoad(true);
              if (setLoad) {
                correctLeadCount(
                  organizationId,
                  (data) => setLoad(data),
                  dispatcher
                );
              }
            }}
          >
            Correct Count
          </button>
          <button
            style={{ marginLeft: '20px' }}
            className={styles.addBox}
            onClick={() => {
              setChangeStageModal && setChangeStageModal(true);
            }}
          >
            Change Stage
          </button>
          <button
            style={{ marginLeft: '20px' }}
            className={styles.addBox}
            onClick={() => {
              setDeleteRecordsModal && setDeleteRecordsModal(true);
            }}
          >
            Delete Records
          </button>
        </>
      )}
      {title === 'Add Api' && (
        <button
          style={{ marginLeft: '20px' }}
          className={styles.addBox}
          onClick={() => {
            setApiModal && setApiModal(true);
          }}
        >
          Add API
        </button>
      )}

      {title === 'Add News Link' && (
        <button
          style={{ marginLeft: '20px' }}
          className={styles.addBox}
          onClick={() => {
            setApiModal && setApiModal(true);
          }}
        >
          Add News Link
        </button>
      )}

      {title === 'Add Api Data' && (
        <>
          <div className={styles.leadContainer}>
            <div className={styles.leadBox}>
              <p className={styles.leadText}>Last 7 Days</p>
              <input
                className={styles.checkbox}
                type="checkbox"
                onChange={(e) => {
                  apiFilter(e, '7');
                }}
                checked={apiFilterData === '7' ? true : false}
              />
            </div>
            <div className={styles.leadBox}>
              <p className={styles.leadText}>Last 30 Days</p>
              <input
                className={styles.checkbox}
                type="checkbox"
                onChange={(e) => {
                  apiFilter(e, '30');
                }}
                checked={apiFilterData === '30' ? true : false}
              />
            </div>
            <div className={styles.leadBox}>
              <p className={styles.leadText}>All</p>
              <input
                className={styles.checkbox}
                type="checkbox"
                onChange={(e) => {
                  apiFilter(e, 'all');
                }}
                checked={apiFilterData === 'all' ? true : false}
              />
            </div>
          </div>
        </>
      )}
      <div className={styles.box}>
        {(
          (
            title !== 'Add Task' &&
            title !== 'drilldown' &&
            title !== 'Add Api' &&
            title !== 'Add Call Logs' &&
            title !== 'Add News Link' &&
            title !== 'Add Api Data' &&
            (
              role !== 'Replicate' ||
              (role === 'Replicate' && title === 'Add Project')
            )
          )
        ) && (
            <button
              className={
                styles.tabButton +
                ' ' +
                styles.leftRounded
              }
              style={{
                background: '#e6e6e6',
                color: '#333',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                padding: '8px 18px',
                fontFamily: "var(--font-family-main)",
                fontSize: "var(--font-size-small)",
                minWidth: 120,
                justifyContent: 'flex-start',
                boxShadow: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
              onClick={() => {
                title === 'Lead Distribution'
                  ? setShowDistributionModal(true)
                  : history.push(path);
              }}
            >
              <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
              {title}
            </button>
          )}
        {showDistributionModal && (
          <DistributionModel
            open={showDistributionModal}
            organization_id={user.organization_id}
            close={() => {
              setShowDistributionModal(false);
            }}
          />
        )}
        {(
          (
            (role === "Admin" && ["Add Task", "Add Call Logs"].includes(title)) ||
            (role === "Replicate" && ["Add Contacts", "Add Call Logs", "Add Project"].includes(title))
          )

        ) && (
            <div className={styles.refreshIcon}>
              <button
                className={styles.tabButton}
                style={{
                  background: '#e6e6e6',
                  color: '#333',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 18px',
                  fontFamily: "var(--font-family-main)",
                  fontSize: "var(--font-size-small)",
                  minWidth: 50,
                  justifyContent: 'center',
                  boxShadow: 'none',
                  border: 'none',
                  cursor: 'pointer'
                }}
                onClick={onExport}
              >
                <BiExport size={30} style={{ marginRight: 6, color: '#272944' }} />
                Export
              </button>
            </div>
          )}

        {show === true && title !== 'drilldown' && (
          <>
            {(userRole === 'Lead Manager' ||
              userRole === 'organization' ||
              userRole === 'Team Lead' || (role === "Admin" && (title === "Add Contacts" || title === "Add Project"))) && (
                <div className={styles.refreshIcon} style={{ marginRight: "-2px" }}>
                  <button
                    className={
                      styles.tabButton +
                      ' ' +
                      (title === 'Add Call Logs' || title === 'Add Task' ? styles.leftRounded : '')
                    }
                    style={{
                      background: '#e6e6e6',
                      color: '#333',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 18px',
                      fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)",
                      minWidth: 50,
                      justifyContent: 'center',
                      boxShadow: 'none',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setExpandImport(!expandImport);
                    }}
                  >
                    <FaChevronDown size={30} style={{ marginRight: 6, color: '#272944' }} />
                    Import/Export
                  </button>
                  {expandImport === true && (
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '37px',
                      }}
                    >
                      <Import
                        onClick={onClick}
                        setExpandImport={(data) => setExpandImport(data)}
                        onExport={onExport}
                        expand={expandImport}
                        close={() => setExpandImport(false)}
                        onCallLogsImport={onCallLogsImport}
                        onNotesImport={onNotesImport}
                        onTasksImport={onTasksImport}
                        title={titleDrillDown || title}
                      />
                    </div>
                  )}
                </div>
              )}
          </>
        )}
        <div className={styles.columnManage}>
          <button
            className={
              styles.tabButton +
              ' ' +
              (title === 'drilldown' ? styles.leftRounded : '')
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 50,
              justifyContent: 'center',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginLeft: 2
            }}
            onClick={() => {
              setColumnModal && setColumnModal(true);
            }}
          >
            <BsColumnsGap size={20} style={{ marginRight: 6, color: '#272944' }} />
            Column Manager
          </button>
        </div>
        <div className={styles.refreshIcon}>
          <button
            className={styles.tabButton}
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 50,
              justifyContent: 'center',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer'
            }}
            onClick={() => {
              if (title === 'Add Task') {
                dispatcher(setRefreshTasks(true));
              } else if (title === 'Add Contacts') {
                dispatcher(setRefreshContacts(true));
              } else if (title === 'Add Call Logs') {
                dispatcher(setRefreshCallLogs(true));
              }
            }}
          >
            <IoIosRefresh
              size={18}
              style={{ color: '#272944', fontWeight: 'bold' }}
            />
            Refresh
          </button>
        </div>
        {/* clear filter */}
        <div className={styles.columnManage}>
          <button
            className={
              styles.tabButton +
              ' ' +
              (title === 'drilldown' ? styles.rightRounded : '')
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 50,
              justifyContent: 'center',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              clearFilter && clearFilter();
            }}
          >
            <BsFilter size={24} style={{ marginRight: 6, color: '#272944' }} />
            Clear Filter
          </button>
        </div>
        {/* clear filter */}
        {/* search box */}
        {title !== 'drilldown' && title !== 'Lead Distribution' && (
          <div style={{ display: 'flex', alignItems: 'center', minWidth: 160 }}>
            <div
              className={styles.rightRounded}
              style={{
                display: 'flex',
                alignItems: 'center',
                width: 160,
                overflow: 'hidden',
                border: '1px solid #e0e0e0',
                background: '#e6e6e6',
                color: '#333',
                height: 34
              }}
            >
              <input
                className={styles.searchText}
                style={{
                  border: 'none',
                  outline: 'none',
                  padding: '0 12px',
                  fontFamily: "var(--font-family-main)",
                  fontSize: "var(--font-size-small)",
                  flex: 1,
                  background: 'transparent',
                  color: '#272944',
                  height: '100%'
                }}
                placeholder="Search..."
                value={value}
                onChange={(val) => {
                  onChange && onChange(val.target.value);
                  setValue(val.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.code === 'Enter') {
                    if (title === 'Add Task') {
                      dispatcher(setTasksSearchString(value));
                    } else if (title === 'Add Contacts') {
                      dispatcher(setContactsSearchString(value));
                    } else if (title === 'Add Call Logs') {
                      dispatcher(setCallsSearchString(value));
                    }
                    else if (title === 'Add Project') {
                      dispatcher(setProjectSearchString(value));
                    }
                    setIsSearched(true);
                  }
                }}
              />
            </div>
          </div>
        )}
        {/* search box */}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    userRole: state.user.role,
    leadsStage: state.leadsStage.stage,
    organizationId: state.organization.id,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ApiTopBar);